import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import generalStyles from '../style/general.module.css';
import heroSkinnyStyles from './style/general.module.css';
import backgroundStyles from './style/background.module.css';

const cx = classNames.bind({
  ...generalStyles,
  ...heroSkinnyStyles,
  ...backgroundStyles,
});

export default function HeroSkinny({
  title,
  copy,
  center,
  maxWidth,
  background,
  children,
  tag,
}) {
  const heroClassName = cx('hero', background);
  const heroSkinnyClassName = cx('heroSkinny', center);
  const titleColor = background === 'white' ? 'black' : 'white';

  return (
    <div className={heroClassName}>
      <div className={heroSkinnyClassName}>
        <PageWrap size="l">
          <Align type="center">
            <MaxWidth value={maxWidth}>
              {title && (
                <Spacing type="margin" size="m" position="bottom">
                  <Heading
                    tag={tag}
                    size="xxxxl"
                    weight="semibold"
                    color={titleColor}
                  >
                    {title}
                  </Heading>
                </Spacing>
              )}
              {copy && (
                <Spacing type="margin" size="l" position="bottom">
                  <Paragraph size="xxl" color="slate">
                    {copy}
                  </Paragraph>
                </Spacing>
              )}
              {children}
            </MaxWidth>
          </Align>
        </PageWrap>
      </div>
    </div>
  );
}

const validTags = ['h1', 'h2'];

HeroSkinny.propTypes = {
  children: PropTypes.node,
  title: propTypeEmptyString,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  copy: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  center: PropTypes.bool,
  background: PropTypes.oneOf(['white', 'black']),
  tag: PropTypes.oneOf(validTags),
};

HeroSkinny.defaultProps = {
  center: false,
  maxWidth: '100%',
  background: 'white',
  tag: 'h1',
};



// WEBPACK FOOTER //
// ./src/components/modules/Hero/HeroSkinny/index.js